import { NgModule } from "@angular/core";
import { SharedModule } from "src/app/shared/shared/shared.module";
import { PosAccessCodeComponent } from "./pos-access-code/pos-access-code.component";
import { PosIdleComponent } from "./pos-idle/pos-idle.component";
import { PosLoginComponent } from "./pos-login/pos-login.component";
import { PosCheckListComponent } from "./pos-order-entry/pos-check-list/pos-check-list.component";
import { PosCanvasItemsComponent } from "./pos-order-entry/pos-main-menu/pos-canvas-items/pos-canvas-items.component";
import { PosItemModifierComponent } from "./pos-order-entry/pos-main-menu/pos-canvas-items/pos-item-modifier/pos-item-modifier.component";
import { PosCanvasRibbonComponent } from "./pos-order-entry/pos-main-menu/pos-canvas-ribbon/pos-canvas-ribbon.component";
import { PosCommandRibbonComponent } from "./pos-order-entry/pos-main-menu/pos-command-ribbon/pos-command-ribbon.component";
import { PosMainMenuComponent } from "./pos-order-entry/pos-main-menu/pos-main-menu.component";
import { PosOnScreenCheckFooterComponent } from "./pos-order-entry/pos-on-screen-check/pos-on-screen-check-footer/pos-on-screen-check-footer.component";
import { PosOnScreenCheckHeaderComponent } from "./pos-order-entry/pos-on-screen-check/pos-on-screen-check-header/pos-on-screen-check-header.component";
import { PosOnScreenCheckItemsComponent } from "./pos-order-entry/pos-on-screen-check/pos-on-screen-check-items/pos-on-screen-check-items.component";
import { PosOnScreenCheckComponent } from "./pos-order-entry/pos-on-screen-check/pos-on-screen-check.component";
import { PosOrderEntryComponent } from "./pos-order-entry/pos-order-entry.component";
import { PosRoutingModule } from "./pos-routing.module";
import { PosComponent } from "./pos.component";

@NgModule({
	declarations: [
		PosComponent,
		PosIdleComponent,
		PosLoginComponent,
		PosOrderEntryComponent,
		PosOnScreenCheckComponent,
		PosAccessCodeComponent,
		PosMainMenuComponent,
		PosCommandRibbonComponent,
		PosCanvasRibbonComponent,
		PosCanvasItemsComponent,
		PosCheckListComponent,
		PosOnScreenCheckItemsComponent,
		PosOnScreenCheckFooterComponent,
		PosOnScreenCheckHeaderComponent,
		PosItemModifierComponent,
	],
	imports: [SharedModule, PosRoutingModule],
})
export class PosModule {}
